import { createWorkbook, createTitle, createHeader, createRowCell, } from "../../../utils/xlsx/xlxsUtils";
var date = new Date().toLocaleDateString("en");
var SPREADSHEET_TITLE = "Admin Export - " + date;
var createRow = function (sheet, row, columns, data) {
    var currentRow = row;
    var isAlt = row % 2 === 1;
    if (columns.length > 0) {
        var itemRow_1 = sheet.getRow(row);
        itemRow_1.height = 20;
        columns.forEach(function (col, ix) {
            var _a, _b;
            var value = "";
            if (!col.cell && col.accessor) {
                value = (_a = data === null || data === void 0 ? void 0 : data[col.accessor]) !== null && _a !== void 0 ? _a : "";
            }
            else if (col.cell) {
                var cellFunc = col.cell;
                value = (_b = cellFunc(data)) !== null && _b !== void 0 ? _b : "";
            }
            createRowCell(itemRow_1, ix + 1, value, isAlt);
        });
    }
    currentRow++;
    return currentRow;
};
var generateTableSpreadsheet = function (_a) {
    var columns = _a.columns, data = _a.data, name = _a.name;
    var workbook = createWorkbook();
    var sheet = workbook.addWorksheet();
    createTitle(sheet, name !== null && name !== void 0 ? name : SPREADSHEET_TITLE, columns.length);
    createHeader(sheet, 2, columns);
    var currentRow = 3;
    data.forEach(function (d) {
        currentRow = createRow(sheet, currentRow, columns, d);
    });
    return workbook;
};
export default generateTableSpreadsheet;
//# sourceMappingURL=tableXlsx.js.map